import _ from "lodash";

function replacePlaceholders(translation, translationParams) {
  let result = translation;
  Object.keys(translationParams).forEach((key) => {
    const paramRegexp = new RegExp(`%${key}%`, "g");
    result = result.replace(paramRegexp, translationParams[key]);
  });
  return result;
}

export const getPageLanguage = function () {
  const params = new URLSearchParams(window.location.search);
  if (window.location.search && params.hasTag?.("lang")) {
    return params.get("lang");
  } else {
    return window.EDRONE_CONTEXT?.user?.lang ?? "en";
  }
};

export const edroneTranslate = function (source, lang, translationKey, translationParams = {}) {
  if (!source) {
    console.warn("Translations not available - make sure that requested bundle is available");
    return translationKey;
  }

  // Support for flat files
  let translation = source[translationKey];
  if (translation) {
    return replacePlaceholders(translation, translationParams);
  }

  // Support for nested files
  translation = _.get(source, `_${translationKey}`);
  if (translation) {
    return replacePlaceholders(translation, translationParams);
  }

  return translationKey;
};
